(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dkdrinks-accueil"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.dkReady) return;
    root.dataset.dkReady = 'true';
    const tabs = [...root.querySelectorAll('[data-dk-tab]')];
    const panels = [...root.querySelectorAll('[data-dk-panel]')];
    const select = (id) => {
      tabs.forEach(tab => tab.setAttribute('aria-current', String(tab.dataset.dkTab === id)));
      panels.forEach(panel => { panel.hidden = panel.dataset.dkPanel !== id; });
    };
    tabs.forEach(tab => tab.addEventListener('click', event => {
      event.preventDefault();
      select(tab.dataset.dkTab);
    }));
    if (tabs.length) {
      const linked = tabs.find(tab => tab.hash === window.location.hash);
      select((linked || tabs[0]).dataset.dkTab);
    }
    root.querySelectorAll('.dk-menu__item').forEach(item => {
      const name = item.querySelector('[data-dk-name]');
      const format = item.querySelector('[data-dk-format]');
      const match = name.textContent.trim().match(/^(.+?)\s+((?:\d+\s*[x×]\s*)?\d+(?:[.,]\d+)?\s*(?:ml|cl|l|litres?)\b.*)$/i);
      if (match) {
        name.textContent = match[1];
        format.textContent = match[2].replace(/\s*[x×]\s*/gi, ' × ').replace(/(\d)\s+(ml|cl|l)\b/gi, '$1\u00a0$2');
        format.hidden = false;
      }
    });
    root.addEventListener('shopify:block:select', event => {
      const panel = event.target.closest('[data-dk-panel]');
      if (panel) select(panel.dataset.dkPanel);
    });
  };
  const scan = () => document.querySelectorAll('.dk-menu').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
